
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payout-report/dashboard",
      function () {
        return require("private-next-pages/payout-report/dashboard/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payout-report/dashboard"])
      });
    }
  